export const API_BASE: string = process.env.URL_ADMIN_API + '/v1/'
